document.addEventListener('DOMContentLoaded', () => {
    const providerContainers = document.querySelectorAll('.provider-container');
    const MD_BREAKPOINT = 768;

    const setProviderHeight = () => {
        const windowWidth = window.innerWidth;

        if (providerContainers) {
            if (windowWidth > MD_BREAKPOINT) {
                let maxHeight = 0;

                /*  Separate loop because containers are linked,
                    meaning you have to reset them all before getting the new max height */
                providerContainers.forEach((container: HTMLDivElement) => {
                    container.style.removeProperty('height'); // Needed for resize event
                });

                providerContainers.forEach((container: HTMLDivElement) => {
                    maxHeight = Math.max(maxHeight, container.offsetHeight);
                });

                providerContainers.forEach((container: HTMLDivElement) => {
                    container.style.height = `${maxHeight}px`;
                });
            } else {
                providerContainers.forEach((container: HTMLDivElement) => {
                    container.style.removeProperty('height');
                });
            }
        }
    };

    const waitForImages = () => {
        const images = document.querySelectorAll('.provider-container img');
        let loadedImages = 0;

        if (images.length === 0) {
            setProviderHeight();

            return;
        }

        images.forEach((img: HTMLElement) => {
            const imageElement = img as HTMLImageElement;
            if (imageElement.complete) {
                loadedImages += 1;
            } else {
                imageElement.addEventListener('load', () => {
                    loadedImages += 1;
                    if (loadedImages === images.length) {
                        setProviderHeight();
                    }
                });
                imageElement.addEventListener('error', () => {
                    loadedImages += 1;
                    if (loadedImages === images.length) {
                        setProviderHeight();
                    }
                });
            }
        });

        if (loadedImages === images.length) {
            setProviderHeight();
        }
    };

    window.addEventListener('load', waitForImages, { once: true });
    window.addEventListener('resize', setProviderHeight);
});
